module.exports = __webpack_public_path__ + "static/media/vegetables1000.d534c790.jpeg";